export default{
    msg:'',
    editar:{},
    lista:'',
    pesquisa:'',
    rublicas:'',
}